<script setup lang="ts">
import { getImgSrc, getOpenGraph, getTwitter } from '@/helpers/useMetaData'

definePageMeta({ middleware: ['search-destination-validation'] })
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/[destination]/[name]',
    fr: '/[destination]/[name]',
  },
})

const { userIsAdmin, userIsPartner } = useAuth()
const stateHousePreviousPage = useState('house-previous-page')
const { data, setData } = useSearchInput()
const { searchDestination } = useDestination()

onBeforeRouteLeave((_, from) => {
  if (from?.name) {
    stateHousePreviousPage.value = {
      name: getRouteName(from),
      params: from.params,
      query: from.query,
    }
  }

  // clear search input "Geographic Area" or unknown location when page change
  if (data.value.location.id?.toString().startsWith('area'))
    setData('location', {})
})

const { isSeoFacet, indexationPage, metaCoverPhotoUrl, metaDesc, metaTitle } =
  searchDestination.value
useHead({
  title: metaTitle,
  meta: [
    {
      name: 'description',
      content: metaDesc,
    },
    ...getOpenGraph(metaTitle, metaDesc, metaCoverPhotoUrl),
    ...getTwitter(metaTitle, metaDesc, metaCoverPhotoUrl),
    ...(isSeoFacet && !indexationPage
      ? [
          {
            id: 'robots',
            name: 'robots',
            content: 'noindex',
          },
        ]
      : []),
  ],
  link: [...getImgSrc(metaCoverPhotoUrl)],
})
</script>

<template>
  <div>
    <LazyDestination v-if="searchDestination.isDestinationPage" />
    <Suspense v-else>
      <LazySearchAdminLayout v-if="userIsAdmin" />
      <LazySearchPartnerLayout v-else-if="userIsPartner" />
      <LazySearchClientLayoutV2 v-else />

      <template #fallback>
        <div class="min-h-screen animate-pulse bg-gray-100" />
      </template>
    </Suspense>
  </div>
</template>
